import PropTypes from "prop-types";
import { useState } from "react";

const UserEjercicioForm = ({ user = [], ejercicios, createEjercicio }) => {
  const [formData, setFormData] = useState({
    id_usuario: user.id_usuario, // Ensure it's always a string
    fecha: ejercicios.fecha || 0,
    duracion: ejercicios.duracion || 0, // Default to "efectivo"
    distancia: ejercicios.distancia || 0, // Default to "efectivo"
    tipo_de_ejercicio: ejercicios.tipo_de_ejercicio || "Correr/Caminar",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await createEjercicio(formData);
      alert("Ejercicio registrado con éxito.");
    } catch (error) {
      console.error("Error registrando el ejercicio:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3>Agregar Entrenamiento</h3>

      <div className="input-group">
        <label className="label">Fecha</label>
        <input
          type="date"
          name="fecha"
          value={formData.fecha}
          onChange={handleChange}
          className="input"
        />
      </div>

      <div className="input-group">
        <label className="label">Tipo de Ejercicio</label>
        <select
          name="tipo_de_ejercicio"
          value={formData.tipo_de_ejercicio}
          onChange={handleChange}
          className="input"
        >
          <option value="Correr/Caminar" selected>Correr/Caminar</option>
          <option value="Gimnasio">Gimnasio</option>
          <option value="Natacion">Natacion</option>
          <option value="Ciclismo">Ciclismo</option>
          <option value="Yoga con Ignacio">Yoga con Ignacio</option>
          <option value="Tecnica con Alfredo">Tecnica con Alfredo</option>
        </select>
      </div>
      <div className="input-group">
        <label className="label">Duracion (min)</label>
        <input
          type="text"
          name="duracion"
          value={formData.duracion}
          onChange={handleChange}
          className="input"
        />
      </div>
      <div className="input-group">
        <label className="label">Distancia (mts)</label>
        <input
          type="text"
          name="distancia"
          value={formData.distancia}
          onChange={handleChange}
          className="input"
        />
      </div>

      <p></p>
      <button type="submit" className="button">
        Registrar Actividad
      </button>
    </form>
  );
};

UserEjercicioForm.propTypes = {
  user: PropTypes.object.isRequired, // Expecting an array of user objects
  ejercicios: PropTypes.array.isRequired,
  createPago: PropTypes.func,
};

export default UserEjercicioForm;
